const UiModalSidePropsOption = {
  close: { type: Boolean, default: true },
  //? 模态框是否显示关闭按钮
  width: { type: [String, Number] },
  height: { type: [String, Number] },
  zIndex: { type: Number, default: 666 },
  spacing: { type: String, default: "0 56px 56px" },
  //? 内间距
  maxWidth: { type: [String, Number] },
  minWidth: { type: [String, Number] },
  minHeight: { type: [String, Number] },
  maxHeight: { type: [String, Number] },
  direction: { type: String, default: "right" },
  closeSize: { type: Number, default: 48 },
  closeIcon: { type: String, default: "close" },
  classExtraName: { type: String }
  //? 模态框class名称,
};
const UiModalSideEmits = {
  open: () => true,
  close: () => true
};

export { UiModalSideEmits, UiModalSidePropsOption };
//# sourceMappingURL=index.mjs.map
